const MyCustomScrollbar = function (scrollDiv, config) {

    let targetDiv = scrollDiv;
    let borderShift = 3;
    let disabled = false;

    let axisXParams = {
        axis: 'x',
        size: 'width',
        clientSize: 'clientWidth',
        cssAxis: 'left',
        clientAxis: 'clientX',
        touchAxis: 'pageX',
        scroll: 'scrollLeft',
        scrollSize: 'scrollWidth'
    };

    let axisYParams = {
        axis: 'y',
        size: 'height',
        clientSize: 'clientHeight',
        cssAxis: 'top',
        clientAxis: 'clientY',
        touchAxis: 'pageY',
        scroll: 'scrollTop',
        scrollSize: 'scrollHeight'
    };

    let targetDivFixedHeight = 0;
    let targetDivFixedWidth = 0;

    let scrollX = false;
    let scrollY = false;

    let posY = 0;
    let posX = 0;

    let defaultConfig = {
        callback_scroll: function () {
        },
        callback_mousedown: function () {
        },
        callback_mouseup: function () {
        },
        callback_mousemove: function () {
        },
        callback_resize: function () {
        }
    };

    parseOptions(defaultConfig, config);

    Object.defineProperties(this, {
        targetDiv: {
            get: function () {
                return targetDiv;
            }
        },
        disabled: {
            get: function () {
                return disabled;
            },
            set: function (isDisabled) {
                if (isBoolean(isDisabled)) {
                    disabled = isDisabled;
                }
            }
        },
        targetDivFixedWidth: {
            get: function () {
                return targetDivFixedWidth;
            },
            set: function (width) {
                if (isNumeric(width)) {
                    targetDivFixedWidth = width;
                }
            }
        },
        targetDivFixedHeight: {
            get: function () {
                return targetDivFixedHeight;
            },
            set: function (height) {
                if (isNumeric(height)) {
                    targetDivFixedHeight = height;
                }
            }
        },
        scrollX: {
            get: function () {
                return scrollX;
            },
            set: function (scroll) {
                if (isBoolean(scroll)) {
                    scrollX = scroll;
                }
            }
        },
        scrollY: {
            get: function () {
                return scrollY;
            },
            set: function (scroll) {
                if (isBoolean(scroll)) {
                    scrollY = scroll;
                }
            }
        },
        posX: {
            get: function () {
                return posX;
            },
            set: function (pos) {
                if (isNumeric(pos)) {
                    posX = pos;
                }
            }
        },
        posY: {
            get: function () {
                return posY;
            },
            set: function (pos) {
                if (isNumeric(pos)) {
                    posY = pos;
                }
            }
        },
        borderShift: {
            get: function () {
                return borderShift;
            },
            set: function (shift) {
                if (isNumeric(shift)) {
                    borderShift = shift;
                }
            }
        },
        axisXParams: {
            get: function () {
                return axisXParams;
            }
        },
        axisYParams: {
            get: function () {
                return axisYParams;
            }
        }
    });

    this.targetDivInit = function () {

        let targetInitWidth = this.targetDivFixedWidth > 0 ? this.targetDivFixedWidth : this.targetDiv.outerWidth();
        let targetInitHeight = this.targetDivFixedHeight > 0 ? this.targetDivFixedHeight : this.targetDiv.outerHeight();
        let targetScrollWidth = this.targetDiv[0].scrollWidth;
        let targetScrollHeight = this.targetDiv[0].scrollHeight;

        this.targetDiv.css({
            'overflow': 'hidden'
        });

        this.targetDiv.attr('style', '');

        let position;

        switch (this.targetDiv.css('position')) {
            case 'relative':
            case 'absolute':
            case 'fixed':
            case 'sticky':
                position = this.targetDiv.css('position');
                break;
            default:
                position = 'relative';
        }

        this.targetDiv.css({
            'position': position,
            'width': targetInitWidth,
            'height': targetInitHeight
        });

        this.targetDiv.data('old-width', targetInitWidth);
        this.targetDiv.data('old-height', targetInitHeight);

        return [targetInitWidth, targetInitHeight, targetScrollWidth, targetScrollHeight];

    };

};

MyCustomScrollbar.prototype.hasScrollbar = function () {
    return this.scrollX || this.scrollY;
};

MyCustomScrollbar.prototype.addScrollbar = function (scrollBox, axisSettings) {

    let scrollbar;

    if (!this.targetDiv.find('.scrollbar-' + axisSettings.axis).length) {

        scrollbar = $('<div class="scrollbar scrollbar-' + axisSettings.axis + '"><div class="scrollbar-slider"></div></div>');
        this.targetDiv.append(scrollbar);

        let self = this;
        scrollbar.on('mousedown', function (e) {
            self['pos' + (axisSettings.axis.toUpperCase())] = e[axisSettings.clientAxis];
        });

        scrollbar.on('touchstart', function (e) {
            let touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            self['pos' + (axisSettings.axis.toUpperCase())] = touch[axisSettings.touchAxis];
        });

    } else {
        scrollbar = this.targetDiv.find('.scrollbar-' + axisSettings.axis);
    }

    let targetDiv = this.targetDiv.get(0);

    scrollbar.css(axisSettings.size, scrollBox.get(0)[axisSettings.clientSize] - 2 * this.borderShift);
    scrollbar.find('.scrollbar-slider').css(axisSettings.size, (((targetDiv[axisSettings.clientSize] * ((targetDiv[axisSettings.clientSize] / scrollBox.get(0)[axisSettings.scrollSize]) * 100)) / 100) - this.borderShift) + 'px');

    scrollbar.css({
        'position': 'absolute',
    });

    scrollbar.css(axisSettings.cssAxis, this.borderShift);

};

MyCustomScrollbar.prototype.detectScrollbars = function (scrollBox) {

    if (this.targetDiv.css('overflow') === 'scroll') {
        scrollBox.css('overflow', 'scroll');
        this.scrollX = true;
        this.scrollY = true;
    } else if (this.targetDiv.css('overflowX') === 'scroll' || this.targetDiv.css('overflowY') === 'scroll') {

        if (this.targetDiv.css('overflowX') === 'scroll') {
            scrollBox.css('overflowX', 'scroll');
            this.scrollX = true;
        } else {
            this.scrollX = false;
            scrollBox.css('overflowX', 'hidden');
        }

        if (this.targetDiv.css('overflowY') === 'scroll') {
            scrollBox.css('overflowY', 'scroll');
            this.scrollY = true;
        } else {
            scrollBox.css('overflowY', 'hidden');
            this.scrollY = false;
        }

    } else {
        this.scrollX = false;
        this.scrollY = false;
        scrollBox.css('overflowX', 'unset');
        scrollBox.css('overflowY', 'unset');
        scrollBox.css('overflow', 'unset');
    }

};

MyCustomScrollbar.prototype.resize = function () {

    let scrollBox = this.targetDiv.find('.custom-scrollbar-wrapper');
    let content = this.targetDiv.find('.custom-scrollbar-content');

    if (this.targetDiv.isVisible()) {

        if (this.targetDivFixedWidth > 0) {
            if (isDefined(this.targetDiv[0].style.width) && parseInt(this.targetDiv[0].style.width) !== parseInt(this.targetDiv.data('old-width'))) {
                this.targetDivFixedWidth = parseInt(this.targetDiv[0].style.width);
            }
        }

        if (this.targetDivFixedHeight > 0) {
            if (isDefined(this.targetDiv[0].style.height) && parseInt(this.targetDiv[0].style.height) !== parseInt(this.targetDiv.data('old-height'))) {
                this.targetDivFixedHeight = parseInt(this.targetDiv[0].style.height);
            }
        }

        this.targetDiv.attr('style', '');

        content.children().detach().appendTo(this.targetDiv);
        scrollBox.hide();

        let [targetInitWidth, targetInitHeight, targetScrollWidth, targetScrollHeight] = this.targetDivInit();

        scrollBox.css({
            'width': targetInitWidth,
            'height': targetInitHeight,
            'display': 'block'
        });

        this.detectScrollbars(scrollBox);

        if (this.hasScrollbar()) {
            this.targetDiv.css({
                'overflow': 'hidden'
            });
        } else {
            this.targetDiv.css({
                'overflow': 'unset'
            });
        }

        this.targetDiv.children().not('.scrollbar, .custom-scrollbar-wrapper').detach().appendTo(content);

        scrollBox.show();

        scrollBox.css({
            'width': this.scrollY ? targetInitWidth + (scrollBox.outerWidth() - content.outerWidth()) : targetInitWidth,
            'height': this.scrollX ? targetInitHeight + (scrollBox.outerHeight() - content.outerHeight()) : targetInitHeight
        });

        scrollBox.get(0).stylesheep = window.getComputedStyle(scrollBox.get(0));

        if (this.scrollX) {
            this.addScrollbar(scrollBox, this.axisXParams);
            content.css('min-width', targetScrollWidth);
        } else {
            this.targetDiv.find('.scrollbar-x').remove();
            content.css('min-width', 'unset');
        }

        if (this.scrollY) {
            this.addScrollbar(scrollBox, this.axisYParams);
            content.css('min-height', targetScrollHeight);
        } else {
            this.targetDiv.find('.scrollbar-y').remove();
            content.css('min-height', 'unset');
        }

    } else {

        this.targetDiv.attr('style', '');
        scrollBox.attr('style', '');

        this.targetDiv.css({
            'overflow': 'unset'
        });

        if (this.targetDivFixedWidth > 0) {
            this.targetDiv.css('width', this.targetDivFixedWidth);
        }

        if (this.targetDivFixedHeight > 0) {
            this.targetDiv.css('height', this.targetDivFixedHeight);
        }

        scrollBox.css({
            'overflow': 'unset',
            'display': 'none',
            'position': 'absolute'
        });

        this.detectScrollbars(scrollBox);
    }

};

MyCustomScrollbar.prototype.makeScroll = function (scrollBox, axis, movePos) {

    let axisParams = this['axis' + axis.toUpperCase() + 'Params'];
    let pos = 'pos' + axis.toUpperCase();

    let scrollbar = this.targetDiv.find('.scrollbar-' + axis);
    let scrollbarSlider = scrollbar.find('.scrollbar-slider');

    if (movePos > this[pos]) {
        scrollbarSlider.css(axisParams.cssAxis, parseFloat(scrollbarSlider.css(axisParams.cssAxis)) + (movePos - this[pos]));
        if (parseFloat(scrollbarSlider.css(axisParams.cssAxis)) > (this.targetDiv.get(0)[axisParams.clientSize] - parseFloat(scrollbarSlider.css(axisParams.size)) - this.borderShift)) {
            scrollbarSlider.css(axisParams.cssAxis, this.targetDiv.get(0)[axisParams.clientSize] - parseFloat(scrollbarSlider.css(axisParams.size)));
        }
    } else if (movePos < this[pos]) {
        scrollbarSlider.css(axisParams.cssAxis, parseFloat(scrollbarSlider.css(axisParams.cssAxis)) - (this[pos] - movePos));
        if (parseFloat(scrollbarSlider.css(axisParams.cssAxis)) < this.borderShift) {
            scrollbarSlider.css(axisParams.cssAxis, this.borderShift);
        }
    }

    scrollBox.get(0)[axisParams.scroll] = ((((parseFloat(scrollbarSlider.css(axisParams.cssAxis)) * 100) / this.targetDiv.get(0)[axisParams.clientSize]) * scrollBox.get(0)[axisParams.scrollSize]) / 100);

    this[pos] = movePos;

    if (document.selection) {
        document.selection.empty();
    } else if (window.getSelection) {
        window.getSelection().removeAllRanges();
    }

};

MyCustomScrollbar.prototype.init = function () {

    if (isDefined(this.targetDiv.data('initialized'))) {
        return;
    }

    let self = this;

    if (!this.targetDiv.hasClass('custom-scrollbar')) {
        this.targetDiv.addClass('custom-scrollbar');
    }

    if (isDefined(this.targetDiv[0].style.width)) {
        this.targetDivFixedWidth = parseInt(this.targetDiv[0].style.width);
    }

    if (isDefined(this.targetDiv[0].style.height)) {
        this.targetDivFixedHeight = parseInt(this.targetDiv[0].style.height);
    }

    let [targetInitWidth, targetInitHeight, targetScrollWidth, targetScrollHeight] = this.targetDivInit();

    let scrollBox = $('<div class="custom-scrollbar-wrapper"></div>');

    scrollBox.css({
        'position': 'absolute'
    });

    this.detectScrollbars(scrollBox);

    if (this.hasScrollbar()) {
        this.targetDiv.css({
            'overflow': 'hidden'
        });
    }

    let scrollbarContentId = uniqid();

    let content = $('<div class="custom-scrollbar-content"></div>');
    content.css({
        'display': 'inline-block'
    });

    this.targetDiv.children().detach().appendTo(content);
    scrollBox.append(content);
    this.targetDiv.append(scrollBox);

    scrollBox.css({
        'width': this.scrollY ? targetInitWidth + (scrollBox.outerWidth() - content.outerWidth()) : targetInitWidth,
        'height': this.scrollX ? targetInitHeight + (scrollBox.outerHeight() - content.outerHeight()) : targetInitHeight
    });

    scrollBox.get(0).stylesheep = window.getComputedStyle(scrollBox.get(0));

    if (this.scrollX) {
        this.addScrollbar(scrollBox, this.axisXParams);
        content.css('min-width', targetScrollWidth);
    }

    if (this.scrollY) {
        this.addScrollbar(scrollBox, this.axisYParams);
        content.css('min-height', targetScrollHeight);
    }

    new ResizeObserver(function () {
        if (!self.disabled) {
            self.resize();
        }
    }).observe(content[0]);

    /* if(editor){
        e.content.setAttribute('contenteditable','true');
        e.content.addEventListener('keyup', SB.resize);
    } */

    this.targetDiv.on('touchmove', function (e) {

        if ($(e.target).closest('.scrollbar').is(self.targetDiv.find('.scrollbar'))) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }

        let axis = 'x';

        if (self.posY) {
            axis = 'y';
        } else if (!self.posX) {
            return;
        }

        let touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];

        let axisParams = self['axis' + axis.toUpperCase() + 'Params'];
        self.makeScroll(scrollBox, axis, touch[axisParams.touchAxis]);

    });

    this.targetDiv.on('mousemove', function (e) {

        let axis = 'x';

        if (self.posY) {
            axis = 'y';
        } else if (!self.posX) {
            return;
        }

        let axisParams = self['axis' + axis.toUpperCase() + 'Params'];
        self.makeScroll(scrollBox, axis, e[axisParams.clientAxis]);

    });

    this.targetDiv.on('mouseup touchend', function (e) {
        self.posX = 0;
        self.posY = 0;
    });

    this.targetDiv.on('change', function () {
        if (!self.disabled) {
            self.resize();
        }
    });

    $(window).on('resize', function () {
        if (!self.disabled) {
            self.resize();
        }
    });

    scrollBox.on('scroll', function (e) {

        e.preventDefault();

        if (self.scrollX) {
            let scrollbar = self.targetDiv.find('.scrollbar-x');
            let scrollbarSlider = scrollbar.find('.scrollbar-slider');

            let leftX = (((parseFloat(scrollBox.get(0)[self.axisXParams.scroll]) * 100) / scrollBox.get(0)[self.axisXParams.scrollSize]) * self.targetDiv.get(0)[self.axisXParams.clientSize]) / 100;

            if (leftX - self.borderShift < self.borderShift) {
                leftX = self.borderShift;
            }

            scrollbarSlider.css(self.axisXParams.cssAxis, leftX);
        }

        if (self.scrollY) {
            let scrollbar = self.targetDiv.find('.scrollbar-y');
            let scrollbarSlider = scrollbar.find('.scrollbar-slider');

            let topY = (((parseFloat(scrollBox.get(0)[self.axisYParams.scroll]) * 100) / scrollBox.get(0)[self.axisYParams.scrollSize]) * self.targetDiv.get(0)[self.axisYParams.clientSize]) / 100;

            if (topY - self.borderShift < self.borderShift) {
                topY = self.borderShift;
            }

            scrollbarSlider.css(self.axisYParams.cssAxis, topY);
        }

    });

    this.targetDiv.data('initialized', true);

};

MyCustomScrollbar.prototype.disable = function () {

    this.disabled = true;
    this.targetDiv.attr('style', '');

    let scrollBox = this.targetDiv.find('.custom-scrollbar-wrapper');
    let content = this.targetDiv.find('.custom-scrollbar-content');

    content.children().detach().appendTo(this.targetDiv);

    this.targetDiv.attr('style', '');
    scrollBox.attr('style', '');

    if (this.targetDivFixedWidth > 0) {
        this.targetDiv.css('width', this.targetDivFixedWidth);
    }

    if (this.targetDivFixedHeight > 0) {
        this.targetDiv.css('height', this.targetDivFixedHeight);
    }

    scrollBox.css({
        'overflow': 'unset',
        'display': 'none',
        'position': 'absolute'
    });

    this.detectScrollbars(scrollBox);

};

MyCustomScrollbar.prototype.enable = function () {

    this.disabled = false;

    let scrollBox = this.targetDiv.find('.custom-scrollbar-wrapper');
    let content = this.targetDiv.find('.custom-scrollbar-content');

    this.targetDiv.children().not('.scrollbar, .custom-scrollbar-wrapper').detach().appendTo(content);

    scrollBox.css('display', 'block');
    this.resize();

};